import React, {Component}from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

const styles = theme => ({
    container: {
        width: '95%'
    },
    root: {
      width: '95%',
      minHeight: '500px',
      //marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
      margin: '0 Auto',
      //display: 'flex',
      //justifyContent: 'center',
    },
    table: {
      tableLayout: 'auto',
      minWidth: 300,
    },
    header:{
        backgroundColor: 'primary',
    },
    leftCell: {
        borderRight: '0.1em solid rgba(224, 224, 224, 1)',
    },
  });

function createData(amountInDispute, fee) {
  return { amountInDispute, fee};
}

class ClausesAgreement extends Component{

  render(){
    const { classes } = this.props;
    return (
        <div className={classes.root}>
             {/* <img src={flow} width="100%" height="100%" /> */}
             <Typography variant="h5" align='justify'  gutterBottom>
               {/* {this.context.t('The following clause can be added by the parties to a contract who wish to have any future disputes referred to efficient arbitration in HKAS’s Online Arbitration Platform:')} */}
             </Typography>
             <Typography variant="h5" align='justify'  gutterBottom>
              {this.context.t('Any dispute or difference arising out of or in connection with this contract shall be referred to and finally determined by arbitration administrated by the Hong Kong Arbitration Society and in accordance with the HKAS Online Arbitration Rules for the time being in force. The arbitration proceedings shall be conducted in English and the Award shall be written in English')}.
            </Typography>
            {/* <Typography variant="h5"  gutterBottom>
              {this.context.t('The parties can fill in the details and sign this Agreement in order to refer the dispute to HKAS Online Arbitration Platform.')}.
            </Typography> */}
        </div>
    );
  }
    
}

ClausesAgreement.contextTypes = {
  t: PropTypes.func
}

export default withStyles(styles)(ClausesAgreement);